module.exports = __webpack_public_path__ + "img/newsletter@2x.90b28e9d.png";